import React from "react";
import { Link } from "@/lib/router";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { formatPrice } from "@/lib/storeApi";
import { AvailabilityBadge } from "@/components/store/AvailabilityBadge";
import { ImageNote } from "@/components/ImageNote";

export const ProductCard = ({ product, index = 0 }) => {
  const { t, lang } = useLang();
  const image = (product.images || [])[0];
  const state = product.availability_state || "AVAILABLE";

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: "easeOut" }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/shop/${product.slug}`} className="group block">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#fdfdfd]">
          {image && (
            <img data-zoom
              src={image}
              alt={t(product.name)}
              loading="lazy"
              className="h-full w-full object-contain p-4 transition-transform duration-700 ease-out group-hover:scale-105"
            />
          )}
          <AvailabilityBadge state={state} className="absolute left-4 top-4 bg-ink/70 backdrop-blur-sm" testid={`card-availability-${product.slug}`} />
          {product.visibility === "founder_only" && (
            <span data-testid={`card-founder-vault-${product.slug}`} className="absolute right-4 top-4 rounded-full border border-gold/40 bg-ink/70 px-3 py-1 text-[10px] uppercase tracking-widest text-gold backdrop-blur-sm">
              Esclusiva Founder
            </span>
          )}
        </div>
        <div className="mt-5">
          {product.fragrance && (
            <span className="text-[11px] uppercase tracking-overline text-gold/70">{product.fragrance}</span>
          )}
          <h3 className="mt-2 font-display text-lg font-light text-white transition-colors duration-300 group-hover:text-gold">
            {t(product.name)}
          </h3>
          {product.is_discovery && <ImageNote className="mt-2" />}
        </div>
      </Link>
    </motion.div>
  );
};
